import { module as ModuleJS } from "modujs";
import { debounce } from "../utils/events";

export default class extends ModuleJS {
    constructor(m) {
        super(m);

        this.name = this.getData('name');
        this.height = this.el.getBoundingClientRect().height;
    }

    init() {
        this.onResize = this.onResize.bind(this);
        this.onResizeDebounced = debounce(this.onResize, 200);

        this.onResize();
        this.bindEvents();
    }

    onResize() {
        this.updateHeight();
        this.setCSSVariable();
    }

    updateHeight() {
        this.height = this.el.getBoundingClientRect().height;
    }

    setCSSVariable() {
        document.documentElement.style.setProperty(
            "--"+this.name+"-height",
            this.height + "px"
        );
    }

    bindEvents(el) {
        window.addEventListener('resize', this.onResizeDebounced);
    }

    update(newContainer) {
        window.removeEventListener('resize', this.onResizeDebounced);
        window.addEventListener('resize', this.onResizeDebounced);
    }

    destroy(oldContainer) {
        window.removeEventListener('resize', this.onResizeDebounced);
    }
}
